import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { MailIcon, AlertCircleIcon, CheckCircleIcon } from 'lucide-react';
export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const {
    resetPassword
  } = useAuth();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (!email) {
      setError('Please enter your email address');
      return;
    }
    try {
      setIsLoading(true);
      await resetPassword(email);
      setMessage('Check your email for password reset instructions');
    } catch (err: any) {
      console.error('Password reset error:', err);
      if (err.code === 'auth/user-not-found') {
        setError('No account found with this email address');
      } else {
        setError('Failed to send password reset email. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] flex items-center justify-center px-4 py-12" data-id="element-4098">
      <div className="max-w-md w-full bg-white rounded-xl shadow-xl overflow-hidden" data-id="element-4099">
        <div className="px-8 py-10" data-id="element-4100">
          <div className="text-center mb-10" data-id="element-4101">
            <h2 className="text-3xl font-bold text-navy-900 mb-2" data-id="element-4102">
              Reset Password
            </h2>
            <p className="text-gray-600" data-id="element-4103">
              Enter your email to receive a password reset link
            </p>
          </div>
          {error && <div className="mb-6 p-4 bg-red-50 border-l-4 border-red-500 text-red-700 flex items-start" data-id="element-4104">
              <AlertCircleIcon className="h-5 w-5 mr-2 flex-shrink-0 mt-0.5" data-id="element-4105" />
              <span data-id="element-4106">{error}</span>
            </div>}
          {message && <div className="mb-6 p-4 bg-green-50 border-l-4 border-green-500 text-green-700 flex items-start" data-id="element-4107">
              <CheckCircleIcon className="h-5 w-5 mr-2 flex-shrink-0 mt-0.5" data-id="element-4108" />
              <span data-id="element-4109">{message}</span>
            </div>}
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-4110">
            <div data-id="element-4111">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4112">
                Email Address
              </label>
              <div className="relative" data-id="element-4113">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-4114">
                  <MailIcon className="h-5 w-5 text-gray-400" data-id="element-4115" />
                </div>
                <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="pl-10 w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-deep-pink focus:border-deep-pink text-gray-900" placeholder="you@example.com" required disabled={isLoading} data-id="element-4116" />
              </div>
            </div>
            <button type="submit" disabled={isLoading} className="w-full bg-deep-pink hover:bg-burgundy text-white font-medium py-3 px-4 rounded-lg transition-colors flex items-center justify-center" data-id="element-4117">
              {isLoading ? <>
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-4118">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-4119"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-4120"></path>
                  </svg>
                  Sending...
                </> : 'Send Reset Link'}
            </button>
          </form>
          <div className="mt-8 text-center" data-id="element-4121">
            <p className="text-gray-600" data-id="element-4122">
              Remember your password?{' '}
              <Link to="/teacher-login" className="text-deep-pink hover:text-burgundy font-medium" data-id="element-4123">
                Sign in
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>;
};